import { gql } from '@apollo/client';

export const SAVE_PROPOSAL = gql`
  mutation ENROLLMENT_SERVICE_saveProposal($proposal: InputProposalV2, $rateSegment: RateSegment, $sponsorId: String) {
    saveProposal(proposal: $proposal, rateSegment: $rateSegment, sponsorId: $sponsorId) {
      id
    }
  }
`;
